import IziToast from 'izitoast'

// noinspection JSUnusedGlobalSymbols
export default class Toast
{
	static _notify_layout = {
		layout             : 2,
		position           : 'topRight',
		progressBar        : false,
		transitionOutMobile: 'fadeOutUp',
		animateInside      : false,
	}

	static success(message)
	{
		IziToast.success(Object.assign(this._notify_layout, {
			message: message,
			timeout: 5000,
			close  : false,
		}))
	}

	static info(message)
	{
		IziToast.info(Object.assign(this._notify_layout, {
			message: message,
			timeout: 5000,
			close  : false,
		}))
	}

	static warning(message)
	{
		IziToast.warning(Object.assign(this._notify_layout, {
			message: message,
			timeout: false,
			close  : true,
		}))

		console.warn(`[Warning] ${message}`)
	}

	static error(message)
	{
		IziToast.error(Object.assign(this._notify_layout, {
			message: message,
			timeout: false,
			close  : true,
		}))

		console.error(`[Error] ${message}`)
	}
}
